import React from 'react';
import {Text, TextTypography} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {classes} from './NoOnlineOrdersMessage.st.css';
import CloseIcon from './CloseIcon.svg';
import {useControllerProps} from '../Widget/ControllerContext';
import {NoOnlineOrdersActions} from './NoOnlineOrdersActions';
import {Badge} from '@wix/wix-ui-icons-common/on-stage';

export enum NoOnlineOrdersMessageDataHooks {
  Root = 'NoOnlineOrdersMessageDataHooks.Root',
  CloseIcon = 'NoOnlineOrdersMessageDataHooks.CloseIcon',
  BadgeIcon = 'NoOnlineOrdersMessageDataHooks.BadgeIcon',
  Title = 'NoOnlineOrdersMessageDataHooks.Title',
  Message = 'NoOnlineOrdersMessageDataHooks.Message',
  CtaButton = 'NoOnlineOrdersMessageDataHooks.CtaButton',
  SecondaryLink = 'NoOnlineOrdersMessageDataHooks.SecondaryLink',
}

export interface NoOnlineOrdersMessageProps {
  onDismissNoPremiumError: () => void;
}

export const NoOnlineOrdersMessage = ({onDismissNoPremiumError}: NoOnlineOrdersMessageProps) => {
  const {
    checkoutSettingsStore: {cannotShip},
    navigationStore: {isOwnerOrPreview},
  } = useControllerProps();

  const localeKeys = useLocaleKeys();
  const isOwnerNoPremium = isOwnerOrPreview && !cannotShip;

  const getTitle = () => {
    if (cannotShip) {
      return localeKeys.checkout.noShippingMerchant.checkoutUnavailable.title();
    }
    if (isOwnerNoPremium) {
      return localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.title();
    }
    return localeKeys.checkout.noPremiumMerchant.checkoutUnavailable.title();
  };

  const getBody = () => {
    if (cannotShip) {
      return localeKeys.checkout.noShippingMerchant.checkoutUnavailable.body();
    }
    if (isOwnerNoPremium) {
      return localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.body();
    }
    return localeKeys.checkout.noPremiumMerchant.checkoutUnavailable.body();
  };

  const iconDataHook = isOwnerNoPremium
    ? NoOnlineOrdersMessageDataHooks.BadgeIcon
    : NoOnlineOrdersMessageDataHooks.CloseIcon;
  const Icon = isOwnerNoPremium ? Badge : CloseIcon;

  return (
    <div data-hook={NoOnlineOrdersMessageDataHooks.Root} className={classes.root}>
      <div data-hook={iconDataHook} className={classes.closeIcon}>
        <Icon size={28} />
      </div>
      <Text data-hook={NoOnlineOrdersMessageDataHooks.Title} className={classes.titleText}>
        {getTitle()}
      </Text>
      <Text data-hook={NoOnlineOrdersMessageDataHooks.Message} typography={TextTypography.runningText}>
        {getBody()}
      </Text>
      {isOwnerNoPremium && (
        <div className={classes.actions}>
          <NoOnlineOrdersActions onDismissNoPremiumError={onDismissNoPremiumError} />
        </div>
      )}
    </div>
  );
};
